module.exports = __webpack_public_path__ + "static/media/solicitud.32b52bda.png";